import React from 'react';
import styled from 'styled-components';
import { CircularProgress } from '@material-ui/core';

const Wrapper = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  height: ${props => props.size}px;
`;

const Loader = ({ isLoading, size = 50 }) =>
  isLoading ? (
    <Wrapper size={size}>
      <CircularProgress size={size} />
    </Wrapper>
  ) : null;

export default Loader;
